export default __webpack_public_path__ + "static/newsletter-5b2bbd0f6b05b700e9c4e294939b254a.png";